import $ from 'jquery'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import { isValidPhoneNumber } from 'libphonenumber-js'
import IMask from 'imask'
import { Alert } from '../functions'

// eslint-disable-next-line no-undef
const object = vnObject

const masks = document.querySelectorAll('.vn-phone-mask')
if (masks) {
  ;[...masks].map((mask) => {
    IMask(mask, {
      mask: '+33 \\00 00 00 00 00',
      lazy: false,
      placeholderChar: 'x',
    })
  })
}

window.Parsley.addValidator('frNumber', {
  requirementType: 'string',
  validateString: function (value) {
    return isValidPhoneNumber(value, 'FR')
  },
})

const form = $('.contact-form')

if (form.length) {
  form.parsley().on('form:success', function () {
    form.attr('data-success', 'true')
  })

  form.parsley().on('form:error', function () {
    form.attr('data-success', 'false')
  })

  $('.contact-form').on('submit', function (e) {
    e.preventDefault()
    e.stopPropagation()

    const $form = $(this)

    $.ajax({
      url: object.ajaxUrl,
      type: 'POST',
      dataType: 'JSON',
      data: $form.serialize() + '&action=' + 'vn_contact',
      beforeSend: () => {
        $form.addClass('sending')
        Alert('warning', object.formWait, false)
      },
      success: (res) => {
        $form.removeClass('sending')

        if (res.success && res.data.redirect) {
          window.location = res.data.redirect
        }

        Alert(res.success, res.data.message)

        res.success && $form[0].reset()
      },
    })
  })

  window._axcb = window._axcb || []
  window._axcb.push(function (axeptio) {
    axeptio.on('consent:saved', function (event) {
      const checkbox = $('#check_consent_1')
      const accepted = event.consent.accept

      checkbox.prop('checked', accepted).trigger('change')
      checkbox.parsley().validate()
    })
  })
}
